import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SmallModuleHead from '@src/pc/index/components/SmallModuleHead';
import Chip from 'Chip';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const Original = ({ originalHead, originalFeed }) => {
    return (
        <div className={styles.original}>
            <Chip id="260479" type="struct" title="原创报道头" content={originalHead}>
                <SmallModuleHead />
            </Chip>
            <Chip id="287350" type="recommend" title="原创报道列表">
                <div className={styles.originalBox}>
                    <div className={styles.originalPicBox}>
                        {originalFeed.slice(0, 1).map((item, index) => {
                            const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                            return (
                                <a key={index} className={styles.originalPicLink} href={item.url} target="_blank">
                                    <img
                                        className={styles.originalPic}
                                        src={formatImageWebpAuto(thumbnail, 380, 214)}
                                    />
                                    <div className={styles.originalPicText}>{item.title}</div>
                                </a>
                            );
                        })}
                    </div>
                    <div className={styles.originalText}>
                        {originalFeed.slice(1, 3).map((item, index) => {
                            return (
                                <div key={index} className={styles.originalTextItem}>
                                    <a className={styles.originalTextLink} href={item.url} target="_blank">
                                        <div className={styles.originalTextDot} />
                                        {item.title}
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Chip>
        </div>
    );
};

Original.propTypes = {
    originalHead: PropTypes.object,
    originalFeed: PropTypes.array,
};

export default errorBoundary(Original);
